'use strict';

export function initInScope($scope) {
    let $navItem = $scope.find('.navbar-nav--main > .js-touch-nav__item');
    let $navItemsLinks = $scope.find('.navbar-nav--main > .js-touch-nav__item > .js-touch-nav__item__toggle');

    //close on escape
    $(document).on('keydown', function (evt) {
        if (evt.keyCode == 27) {
            $navItem.removeClass('is-open');
            $navItem.removeAttr('tabindex');
            $navItemsLinks.attr('tabindex', '0');
        }
    });

    $navItemsLinks.on('keydown', function (evt) {
        if(window.matchMedia('(min-width: 768px)').matches){
            let $item = $(this).closest('.js-touch-nav__item');

            if (evt.keyCode == 9) {
                evt.preventDefault();
                evt.stopImmediatePropagation();

                $navItem.removeClass('is-open');
                $navItem.removeAttr('tabindex');
            }

            if (evt.keyCode == 9 && !$item.hasClass('is-open')) {
                $(this).blur();
                $item.addClass('is-open');
            }
        }
    });
}

